<template>
  <div class="layout--main" :class="[navbarClasses, footerClasses, {'app-page': isAppPage}]">
    <the-customizer
      @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor"
      :navbarType="navbarType"
      :navbarColor="navbarColor"
      :footerType="footerType"
      @updateFooter="updateFooter"
      :routerTransition="routerTransition"
      @updateRouterTransition="updateRouterTransition"
      v-if="!disableCustomizer"
    />
    <vx-sidebar
      :sidebarItems="sidebarItems"
      :iconLogo="'logo-icon.png'"
      :logo="'logo-name.png'"
      title="Smart In-Outs"
      parent=".layout--main"
    />
    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay"></div>
      <div class="content-wrapper">
        <the-navbar
          :navbarColor="navbarColor"
          :class="[{'text-white': isNavbarDark && !isThemeDark}, {'text-base': !isNavbarDark && isThemeDark}]"
        />
        <div class="router-view">
          <div class="router-content" :class="{'mt-0': navbarType == 'hidden'}">
            <transition :name="routerTransition">
              <div
                class="router-header flex flex-wrap items-center mb-6"
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
              >
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light' : $route.meta.breadcrumb}"
                >
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" />
                <vs-dropdown class="ml-auto md:block hidden" vs-trigger-click>
                  <vs-button radius icon="icon-settings" icon-pack="feather"></vs-button>

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <router-link to="/pages/profile" class="flex items-center">
                        <feather-icon
                          icon="UserIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Profile</span>
                      </router-link>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <router-link to="/apps/todo" class="flex items-center">
                        <feather-icon
                          icon="CheckSquareIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Tasks</span>
                      </router-link>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <router-link to="/apps/email" class="flex items-center">
                        <feather-icon
                          icon="MailIcon"
                          class="inline-block mr-2"
                          svgClasses="w-4 h-4"
                        />
                        <span>Inbox</span>
                      </router-link>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </transition>
            <div class="content-area__content">
              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle"></router-view>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import VxSidebar from "@/layouts/components/vx-sidebar/VxSidebar.vue";
import TheCustomizer from "../components/customizer/TheCustomizer.vue";
import TheNavbar from "../components/TheNavbar.vue";
import TheFooter from "../components/TheFooter.vue";
import themeConfig from "@/../themeConfig.js";
import { EventBus } from '@/mixins/mixin.js';

//import sidebarItems from "@/layouts/components/vx-sidebar/sidebarItems.js";

export default {
  data() {
    return {
      navbarType: themeConfig.navbarType || "floating",
      navbarColor: themeConfig.navbarColor || "#fff",
      footerType: themeConfig.footerType || "static",
      routerTransition: themeConfig.routerTransition || "none",
      isNavbarDark: false,
      routeTitle: this.$route.meta.pageTitle,
      sidebarItems: [],
      disableCustomizer: themeConfig.disableCustomizer,
      windowWidth: window.innerWidth //width of windows
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
      this.liveInOutStatus();
    },
    isThemeDark(val) {
      if (this.navbarColor == "#fff" && val) {
        this.updateNavbarColor("#10163a");
      } else {
        this.updateNavbarColor("#fff");
      }
    }
  },
  computed: {
    isAppPage() {
      if (this.$route.path.includes("/apps/")) return true;
      else return false;
    },
    isThemeDark() {
      return this.$store.state.theme == "dark";
    },
    sidebarWidth() {
      return this.$store.state.sidebarWidth;
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.sidebarWidth == "default") return "content-area-default";
      else if (this.sidebarWidth == "reduced") return "content-area-reduced";
      else if (this.sidebarWidth) return "content-area-full";
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType == "hidden",
        "navbar-sticky": this.navbarType == "sticky",
        "navbar-static": this.navbarType == "static",
        "navbar-floating": this.navbarType == "floating"
      };
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType == "hidden",
        "footer-sticky": this.footerType == "sticky",
        "footer-static": this.footerType == "static"
      };
    },
    is_url_disabled(){
     if (this.$store.state.uInfo.is_plan_expire) {
        return true;
      }else if (this.$store.state.uInfo.is_first_time_login && this.$store.state.uInfo.is_owner && this.$store.state.uInfo.is_profile_complete == false) {
        return true;
      }else{
        return false
      }
      },
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSidebarWidth();
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", false);
        this.$store.dispatch("updateSidebarWidth", "no-sidebar");
      } else if (this.windowWidth < 1200) {
        this.$store.dispatch("updateSidebarWidth", "reduced");
      } else {
        this.$store.commit("TOGGLE_IS_SIDEBAR_ACTIVE", true);
      }
    },
    getSidebarItems() {
      let obj = [
        // {
        //     url: "/dashboard",
        //     name: "Dashboard",
        //     slug: "dashboard",
        //     icon: "HomeIcon",
        // }
      ];
      if (this.$store.state.uInfo.role === "SA") {
        obj.push(
          {
            url: "/admin/dashboard",
            name: "Dashboard",
            slug: "admin-dashboard",
            icon: "HomeIcon"
          },
          {
            url: "/admin/manage-users",
            name: "Manage Users",
            slug: "admin-manage-users",
            icon: "UsersIcon"
          },
          {
            url: "/admin/manage-organisation",
            name: "Organisations",
            slug: "admin-manage-organisation",
            icon: "UsersIcon"
          },
          {
            url: "/admin/subcription-plan",
            name: "Subcription Plans",
            slug: "admin-subcription-plan",
            icon: "LayersIcon"
          },
          {
            url: "/admin/payment-list",
            name: "Payment History",
            slug: "admin-payment-list",
            icon: "CreditCardIcon"
          }
        );
      }
      if (
        this.$store.state.uInfo.role === "CA" ||
        this.$store.state.uInfo.role === "HR"
      ) {
        obj.push({
          url: "/organization/dashboard",
          name: "Dashboard",
          slug: "organization-dashboard",
          icon: "HomeIcon",
          isDisabled: this.is_url_disabled
        });
      }
      if (this.$store.state.uInfo.role === "U") {
        obj.push({
          url: "/user/dashboard",
          name: "Dashboard",
          slug: "user-dashboard",
          icon: "HomeIcon",
          isDisabled: this.is_url_disabled
        });
      }
      if (
        this.$store.state.uInfo.role === "CA" ||
        this.$store.state.uInfo.role === "HR"
      ) {
        obj.push(
          // {
          //     url: "/organization/dashboard",
          //     name: "Dashboard",
          //     slug: "organization-dashboard",
          //     icon: "HomeIcon",
          // },
          /*{
            url: "/organization/timesheet",
            name: "Timesheet",
            slug: "organization-users-ststus",
            icon: "ClockIcon",
            isDisabled: this.is_url_disabled
          },*/
          {
            url: "/organization/v2/timesheet",
            name: "Timesheet",
            slug: "organization-users-ststus",
            icon: "ClockIcon",
            isDisabled: this.is_url_disabled
          },
          {
            url: "/organization/leave",
            name: "Leave",
            slug: "leave",
            icon: "UserIcon",
            isDisabled: this.is_url_disabled
          },
          {
            url: "/organization/manage-vehicles",
            name: "Vehicles",
            slug: "organization-manage-vehicles",
            image: require("@/assets/images/logo/vehicle.svg"),
            isImage: true,
            isDisabled: this.is_url_disabled
          },
          {
            url: "/organization/manage-users",
            name: "Manage Users",
            slug: "organization-manage-users",
            icon: "UsersIcon",
            isDisabled: this.is_url_disabled
          },
          {
            url: "/organization/manage-offices",
            name: "Offices",
            slug: "organization-manage-Offices",
            icon: "MapIcon",
            isDisabled: this.is_url_disabled
          },
          {
            url: "/organization/manage-departments",
            name: "Departments",
            slug: "organization-manage-departments",
            icon: "MapPinIcon",
            isDisabled: this.is_url_disabled
          },

          /*   {
                          url: "/organization/vehicle/timesheet",
                          name: "Vehicle Timesheet",
                          slug: "organization-vehicle-timesheet",
                          icon: "ClockIcon",
                          isDisabled: this.is_url_disabled,
                      }, */

          /*    {
                            url: "/organization/view-fault",
                           name: "View Faults",
                           slug: "organization-view-fault",
                           icon: "AlertCircleIcon",
                           isDisabled: this.is_url_disabled,
                       }, */
          {
            url: "/organization/quick-pick",
            name: "Quick Picks",
            slug: "organization-quick-pick",
            icon: "ImageIcon",
            isDisabled: this.is_url_disabled
          },
          /*    {
                           url: "/organization/payment-list",
                           name: "Payment History",
                           slug: "organization-payment-list",
                           icon: "CreditCardIcon"
                       }, */
          {
            url: "/organization/settings",
            name: "Company Settings",
            slug: "organization-manage-holidays",
            icon: "SettingsIcon"
          }
        );
      }
      if (this.$store.state.uInfo.role === "U") {
        obj.push(
          // {
          //     url: "/organization/dashboard",
          //     name: "Dashboard",
          //     slug: "organization-dashboard",
          //     icon: "HomeIcon",
          // },
          /*{
            url: "/user/timesheet",
            name: "Timesheet",
            slug: "user-timesheet",
            icon: "ClockIcon"
          },*/
          {
            url: "/user/v2/timesheet",
            name: "Timesheet",
            slug: "user-timesheet",
            icon: "ClockIcon",
            isDisabled: this.is_url_disabled
          },
          {
            url: "/user/manage-vehicles",
            name: "Vehicles",
            slug: "user-vehicles",
            image: require("@/assets/images/logo/vehicle.svg"),
            isImage: true,
            isDisabled: this.is_url_disabled
          },
          {
            url: "/user/leave",
            name: "Leave",
            slug: "leave",
            icon: "UserIcon",
            isDisabled: this.is_url_disabled
          },
          {
            url: "/profile",
            name: "Profile",
            slug: "profile",
            icon: "UserIcon",
            isDisabled: this.is_url_disabled
          }
        );
      }
     /* obj.push({
        url: "/help-center",
        name: "Help Center",
        icon: "HelpCircleIcon"
      });*/
      this.sidebarItems = obj;
    }
  },
  mounted(){
    EventBus.$on('menuCHanges', () => {
      this.getSidebarItems()
    });
  },
  created() {
    this.setSidebarWidth();
    this.getSidebarItems();
    if (this.navbarColor == "#fff" && this.isThemeDark) {
      this.updateNavbarColor("#10163a");
    } else {
      this.updateNavbarColor(this.navbarColor);
    }
  },
  components: {
    VxSidebar,
    TheNavbar,
    TheFooter,
    TheCustomizer,
    EventBus
  }
};
</script>
